import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { INITIAL_LOADING_STATUS } from './app-loading.model';
import { AppLoadingService } from './app-loading.service';

export const ClearInitialLoadingStatusGuard: CanActivateFn = () => {
  inject(AppLoadingService).clearLoading(INITIAL_LOADING_STATUS.id);
  return true;
};
